import React from 'react';
import {InertiaLink, useForm, usePage} from '@inertiajs/inertia-react';
import Layout from '@/Shared/Layout';
import LoadingButton from '@/Shared/LoadingButton';
import TextInput from '@/Shared/TextInput';
import SelectInput from '@/Shared/SelectInput';
import FileInput from '@/Shared/FileInput';
import { generate } from '@wcj/generate-password';
import PermissionsGate from "@/Shared/PermissionsGate";

const Create = () => {
  const { data, setData, errors, post, processing } = useForm({
    first_name: '',
    last_name: '',
    email: '',
    password: '',
    admin_role_id: '3',
    photo: ''
  });

  function handleSubmit(e) {
    e.preventDefault();
    post(route('admin-users.store').url());
  }

  const handleGeneratePassword = () => {
    setData('password', generate({ length: 23 , special: false}))
  }


  return (
    <div>
      <div>
        <h1 className="mb-8 text-3xl font-bold">
          <InertiaLink
            href={route('admin-users')}
            className="text-indigo-600 hover:text-indigo-700"
          >
            Users
          </InertiaLink>
          <span className="font-medium text-indigo-600"> /</span> Create
        </h1>
      </div>
      <div className="max-w-3xl overflow-hidden bg-white rounded shadow">
        <form name="createForm" onSubmit={handleSubmit}>
          <div className="flex flex-wrap p-8 -mb-8 -mr-6">
            <TextInput
              className="w-full pb-8 pr-6 lg:w-1/2"
              label="First Name"
              name="first_name"
              errors={errors.first_name}
              value={data.first_name}
              onChange={e => setData('first_name', e.target.value)}
            />
            <TextInput
              className="w-full pb-8 pr-6 lg:w-1/2"
              label="Last Name"
              name="last_name"
              errors={errors.last_name}
              value={data.last_name}
              onChange={e => setData('last_name', e.target.value)}
            />
            <TextInput
              className="w-full pb-8 pr-6 lg:w-1/2"
              label="Email"
              name="email"
              type="email"
              errors={errors.email}
              value={data.email}
              onChange={e => setData('email', e.target.value)}
            />
            <div className={'flex  items-center w-full pb-8 pr-6 lg:w-1/2'}>
              <TextInput
                className="w-full"
                label="Password"
                name="password"
                errors={errors.password}
                value={data.password}
                onChange={e => setData('password', e.target.value)}
              />
              <div className={'btn-default mt-3.5 px-2 py-3 cursor-pointer'} onClick={handleGeneratePassword}>Generate</div>
            </div>
            <SelectInput
              className="w-full pb-8 pr-6 lg:w-1/2"
              label="Role"
              name="role"
              errors={errors.admin_role_id}
              value={data.admin_role_id}
              onChange={e => setData('admin_role_id', e.target.value)}
            >
              <PermissionsGate scopes={['create-super_admin']}><option value="1">Super Admin</option></PermissionsGate>
              <PermissionsGate scopes={['create-admin']}><option value="2">Admin</option></PermissionsGate>
              <PermissionsGate scopes={['create-user']}><option value="3">User</option></PermissionsGate>
              <PermissionsGate scopes={['create-owner']}><option value="4">Owner</option></PermissionsGate>
            </SelectInput>
            <FileInput
              className="w-full pb-8 pr-6 lg:w-1/2"
              label="Photo"
              name="photo"
              accept="image/*"
              errors={errors.photo}
              value={data.photo}
              onChange={photo => setData('photo', photo)}
            />
          </div>
          <div className="flex items-center justify-end px-8 py-4 bg-gray-100 border-t border-gray-200">
            <LoadingButton
              loading={processing}
              type="submit"
              className="btn-default"
            >
              Create User
            </LoadingButton>
          </div>
        </form>
      </div>
    </div>
  );
};

Create.layout = page => <Layout title="Create User" children={page} />;

export default Create;
